<template>
  <div class="view-about">
    <page-header title="About"/>
    <div class="container">
      <div class="about-text">
        <h3 class="c-primary">About Wisteria Lodge</h3>
        <p>Wisteria Lodge is a self-catering cottage located on the owner’s property, which is situated in Roodepoort. It is ideal for a couple or a small family looking for a comfortable stopover close to various facilities.</p>
        <p>This cottage has its own private entrance and is separate from the main house. The unit comprises 1 bedroom equipped with a double bed and an en-suite bathroom with a shower-over-bath, basin and toilet. The living area has an open-plan layout and there is a kitchen that contains a fridge-freezer combination, oven with stove, microwave and built-in cupboards to store crockery and cutlery.</p>
        <p>The lounge has comfortable seating and there is a TV with the full DStv bouquet of channels. Guests are also welcome to make use of the braai facilities on the property and there is secure parking available for 1 vehicle. Small, well-behaved pets are also welcome by prior arrangement.</p>
        <p>Wisteria Lodge is within close proximity of various shops, restaurants and other facilities. Johannesburg Park Station, Sandton and the Cradle of Human Kind are a 30 to 50-minute drive away from the property.</p>
      </div>
      <div class="collapsible">
        <h3 class="collapsible-header flex justify-between align-center c-primary" @click="toggleShown">
          Features
          <icon width="16" colour="#b95a25"><icon-down/></icon>
        </h3>
        <div class="collapsible-content">
          <ul>
            <li>1 queen bed</li>
            <li>Braai area</li>
            <li>Secure Parking</li>
            <li>Free WiFi</li>
            <li>Full DSTV</li>
            <li>Self-catering</li>
            <li>Fan in bedroom</li>
            <li>Linen</li>
            <li>Open-plan lounge and kitchen area</li>
        </ul>
        </div>
      </div>
      <div class="collapsible">
        <h3 class="collapsible-header flex justify-between align-center c-primary" @click="toggleShown">
          Appliances
          <icon width="16" colour="#b95a25"><icon-down/></icon>
        </h3>
        <div class="collapsible-content">
          <ul>
            <li>Refrigerator</li>
            <li>Microwave</li>
            <li>Oven</li>
            <li>Stove</li>
            <li>Iron</li>
            <li>Hair dryer</li>
          </ul>
        </div>
      </div>
      <div class="collapsible">
        <h3 class="collapsible-header flex justify-between align-center c-primary" @click="toggleShown">
          Bathroom
          <icon width="16" colour="#b95a25"><icon-down/></icon>
        </h3>
        <div class="collapsible-content">
          <ul>
            <li>En-suite</li>
            <li>Shower</li>
            <li>Bath</li>
            <li>Toilet</li>
            <li>Soaps included</li>
          </ul>
        </div>
      </div>
      <div class="collapsible">
        <h3 class="collapsible-header flex justify-between align-center c-primary" @click="toggleShown">
          Facilities
          <icon width="16" colour="#b95a25"><icon-down/></icon>
        </h3>
        <div class="collapsible-content">
          <ul>
            <li>Airport transfers by arrangement</li>
            <li>Laundry service</li>
            <li>Breakfast and dinner by arrangement</li>
            <li>Personal gate remote</li>
            <li>Room servicing on demand</li>
          </ul>
        </div>
      </div>
      <div class="collapsible">
        <h3 class="collapsible-header flex justify-between align-center c-primary" @click="toggleShown">
          Other Details
          <icon width="16" colour="#b95a25"><icon-down/></icon>
        </h3>
        <div class="collapsible-content">
          <ul>
            <li>Cash and EFT payments accepted</li>
            <li>No smoking indoors</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiSquare from '../ui/LiSquare'
export default {
  name: 'About',
  components: {
    LiSquare
  },
  methods: {
    toggleShown () {
      const parent = event.target.parentNode || undefined
      const childIcon = event.target.childNodes[1] || undefined
      if (parent) {
        parent.classList.toggle('shown')
      }
      if (childIcon) {
        childIcon.classList.toggle('inverse')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/About.vue